import customThemeColors from './customThemeColors';

/**
 * Generate custom theme overrides from custom colors array
 *
 * @param {number} selectedIndex
 * @returns {object} - Overrides object to merge with MUI & Sovos themes
 */
const generateCustomTheme = function () {
  let colorThemes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : customThemeColors;
  let logoAlt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let logoUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let selectedIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (selectedIndex === 0) {
    // the default Sovos theme
    return {
      components: {
        SovosNavigation: {
          logoAlt,
          logoUrl
        }
      }
    };
  }
  return {
    components: {
      SovosNavigation: {
        logoAlt,
        logoUrl,
        styleOverrides: {
          gradientBottom: colorThemes[selectedIndex].colors.gradientBottom,
          gradientTop: colorThemes[selectedIndex].colors.gradientTop,
          highlights: colorThemes[selectedIndex].colors.highlights,
          productIconColor: colorThemes[selectedIndex].colors.productIconColor,
          textColor: colorThemes[selectedIndex].colors.textColor
        }
      }
    }
  };
};
export default generateCustomTheme;